import { styled } from 'styled-components';
import { IGlobaVariables } from '../../../components/Layout/styles';
import { IHero3, defaultParams } from './params';

import getBackgroundImageStyles from '../../../utils/getBackgroundImageStyles';

const Styles = styled.div<{
  theme?: IGlobaVariables;
  $config: IHero3;
}>`
  .hero {
    position: relative;
    background: ${({ $config: styles }) => getBackgroundImageStyles(styles.backgroundImage)};
    background-position: center;
    background-size: cover;

    .container {
      min-height: 400px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      max-width: 100%;
      width: 700px;
      margin: ${({ $config: styles }) =>
          styles.group_blenda && styles.group_blenda.boolean_showBlenda === 'true' ? '15px' : 0}
        auto;
      padding: ${({ $config: styles }) =>
        styles.group_blenda && styles.group_blenda.boolean_showBlenda === 'true'
          ? styles.group_blenda.padding
          : '15px 0'};
      background: ${({ $config: styles }) =>
        styles.group_blenda && styles.group_blenda.boolean_showBlenda === 'true'
          ? styles.group_blenda.backgroundColor
          : 'transparent'};
      border-radius: ${({ $config: styles }) =>
        styles.group_blenda && styles.group_blenda.boolean_showBlenda === 'true'
          ? styles.group_blenda.borderRadius
          : 0};
    }

    &-siteName {
      color: ${({ $config: styles }) => styles.group_siteName.color};
      font-family: ${({ $config: styles }) => styles.group_siteName.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_siteName.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_siteName.fontSize};
      line-height: ${({ $config: styles }) => styles.group_siteName.lineHeight};
      font-style: ${({ $config: styles }) => styles.group_siteName.fontStyle};
      margin-bottom: 20px;
      text-align: center;
    }

    &-header {
      color: ${({ $config: styles }) => styles.group_header.color};
      font-family: ${({ $config: styles }) => styles.group_header.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_header.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_header.fontSize};
      line-height: ${({ $config: styles }) => styles.group_header.lineHeight};
      font-style: ${({ $config: styles }) => styles.group_header.fontStyle};
      margin-bottom: 20px;
      text-align: center;
    }

    &-description {
      color: ${({ $config: styles }) => styles.group_description.color};
      font-family: ${({ $config: styles }) => styles.group_description.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_description.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_description.fontSize};
      line-height: ${({ $config: styles }) => styles.group_description.lineHeight};
      font-style: ${({ $config: styles }) => styles.group_description.fontStyle};
      text-align: center;
      margin-bottom: 0;
    }
  }
`;

export default Styles;
